import { render, staticRenderFns } from "./OnlineCapacity.vue?vue&type=template&id=77070c56&scoped=true"
import script from "./OnlineCapacity.vue?vue&type=script&lang=js"
export * from "./OnlineCapacity.vue?vue&type=script&lang=js"
import style0 from "./OnlineCapacity.vue?vue&type=style&index=0&id=77070c56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77070c56",
  null
  
)

export default component.exports